import { clsx } from 'clsx'
import { type ComponentPropsWithRef, type ReactElement } from 'react'

import { IconSprites } from '@constants/enums/sprites'

import { Column } from '@components/ui-core/column/column'
import { Icon } from '@components/ui-core/icon/icon'
import { Stack } from '@components/ui-core/stack/stack'

import { HeroCard } from '@custom/components/hero-card/hero-card'

import styles from './agents.module.css'

type AgentsProps = ComponentPropsWithRef<'div'>

const AGENTS = [
  {
    id: 0,
    variant: IconSprites.Hero,
    selected: true,
  },
  {
    id: 1,
    variant: IconSprites.GrammarlyLogo,
  },
  {
    id: 2,
    variant: IconSprites.Humanizer,
  },
  {
    id: 3,
    variant: IconSprites.CitationFinder,
  },
  {
    id: 4,
    variant: IconSprites.Calendar,
  },
]

export function Agents(props: AgentsProps): ReactElement {
  const { className, ...rest } = props

  return (
    <HeroCard className={clsx(styles.agents, className)} {...rest}>
      <Column gap="2x">
        {AGENTS.map(agent => (
          <Stack className={styles.agent} key={agent.id}>
            {agent.selected && <div className={styles.selected}></div>}
            <Icon variant={agent.variant} className={styles.icon} />
          </Stack>
        ))}
      </Column>
    </HeroCard>
  )
}
